import { render, staticRenderFns } from "./UnderConstruction.vue?vue&type=template&id=0e8d4e40&"
import script from "./UnderConstruction.vue?vue&type=script&lang=ts&"
export * from "./UnderConstruction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports